<div class="flex flex-col max-w-2xl w-full max-h-[85vh] overflow-hidden bg-white rounded-2xl shadow-2xl relative">
    <!-- Header Modal -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-slate-50/60">
        <div class="flex items-center gap-3">
            <div 
                class="w-10 h-10 rounded-xl flex items-center justify-center shadow-sm"
                [style.background-color]="data.color_primario || '#3b82f6'">
                <mat-icon [svgIcon]="'heroicons_outline:ticket'" class="!w-6 !h-6 !text-white"></mat-icon>
            </div>
            <div>
                <h3 class="text-lg font-bold text-slate-800 m-0 leading-tight">Confirmar Envío de Ticket</h3>
                <p class="text-xs text-slate-500 m-0">Revisá los datos antes de crear el ticket</p>
            </div>
        </div>
        <button 
            type="button" 
            (click)="cancelar()"
            class="text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg p-1.5 transition-colors">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="!w-5 !h-5"></mat-icon>
        </button>
    </div>

    <!-- Contenido Scrollable -->
    <div class="flex-1 overflow-y-auto p-6 space-y-5 custom-dialog-scrollbar">
        <!-- Asunto / Título (Sin JED) -->
        <div>
            <span class="text-xs font-semibold uppercase tracking-wider text-slate-400 block mb-1">Título del Ticket</span>
            <div class="text-base font-bold text-slate-800 bg-slate-50 border border-slate-200/70 rounded-xl px-4 py-3">
                {{ data.descripcion }}
            </div>
        </div>

        <!-- Módulo, Menú y Usuario -->
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div class="bg-slate-50/80 border border-slate-200/60 rounded-xl p-3">
                <span class="text-[11px] font-medium text-slate-400 uppercase tracking-wider block mb-1">Módulo</span>
                <span class="text-sm font-semibold text-slate-700 truncate block">{{ data.modulo || 'No especificado' }}</span>
            </div>
            <div class="bg-slate-50/80 border border-slate-200/60 rounded-xl p-3">
                <span class="text-[11px] font-medium text-slate-400 uppercase tracking-wider block mb-1">Menú / Pantalla</span>
                <span class="text-sm font-semibold text-slate-700 truncate block">{{ data.menu || 'No especificado' }}</span>
            </div>
            <div class="bg-slate-50/80 border border-slate-200/60 rounded-xl p-3">
                <span class="text-[11px] font-medium text-slate-400 uppercase tracking-wider block mb-1">Reportado por</span>
                <span class="text-sm font-semibold text-slate-700 truncate block">{{ data.usuario || 'Usuario actual' }}</span>
            </div>
        </div>

        <!-- Detalle del Ticket -->
        <div>
            <span class="text-xs font-semibold uppercase tracking-wider text-slate-400 block mb-1">Detalle del problema</span>
            <div class="bg-slate-50 border border-slate-200/70 rounded-xl p-4 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed max-h-48 overflow-y-auto">
                {{ data.detalle }}
            </div>
        </div>

        <!-- Adjuntos -->
        <div>
            <div class="flex items-center justify-between mb-2">
                <span class="text-xs font-semibold uppercase tracking-wider text-slate-400">Archivos Adjuntos (Clic para ver completo)</span>
                <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">
                    {{ data.adjuntos.length }} {{ data.adjuntos.length === 1 ? 'archivo' : 'archivos' }}
                </span>
            </div>

            <!-- Si no hay adjuntos -->
            <div *ngIf="!data.adjuntos || data.adjuntos.length === 0" 
                 class="border border-dashed border-slate-200 rounded-xl p-4 text-center text-xs text-slate-400">
                No se adjuntaron archivos a este ticket.
            </div>

            <!-- Grilla de Adjuntos -->
            <div *ngIf="data.adjuntos && data.adjuntos.length > 0" class="grid grid-cols-2 sm:grid-cols-3 gap-3">
                <div *ngFor="let adjunto of data.adjuntos; let idx = index" 
                     (click)="verAdjuntoCompleto(adjunto)"
                     class="group relative border border-slate-200 rounded-xl overflow-hidden bg-slate-50/50 hover:border-blue-400 hover:shadow-md transition-all flex flex-col cursor-pointer">
                    
                    <!-- Previsualización -->
                    <div class="h-24 w-full bg-slate-100 flex items-center justify-center overflow-hidden relative">
                        <img *ngIf="esImagen(adjunto.extension)" 
                             [src]="'data:image/' + adjunto.extension + ';base64,' + adjunto.base64" 
                             alt="Adjunto" 
                             class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200">
                        
                        <div *ngIf="!esImagen(adjunto.extension)" class="flex flex-col items-center justify-center text-slate-400">
                            <mat-icon [svgIcon]="obtenerIconoArchivo(adjunto.extension)" class="!w-8 !h-8 text-slate-500"></mat-icon>
                            <span class="text-[10px] font-bold uppercase tracking-wider text-slate-500 mt-1">{{ adjunto.extension }}</span>
                        </div>

                        <!-- Overlay hover con ícono de zoom / expandir -->
                        <div class="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                            <mat-icon [svgIcon]="'heroicons_outline:arrows-pointing-out'" class="!w-6 !h-6 !text-white"></mat-icon>
                        </div>
                    </div>

                    <!-- Nombre del adjunto -->
                    <div class="p-2 bg-white border-t border-slate-100 flex items-center justify-between gap-1">
                        <span class="text-xs font-medium text-slate-600 truncate flex-1" [title]="adjunto.nombre">
                            {{ adjunto.nombre }}
                        </span>
                        <span class="text-[10px] uppercase font-bold text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">
                            {{ adjunto.extension }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Modal -->
    <div class="px-6 py-4 border-t border-slate-100 bg-slate-50/80 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-3">
        <button 
            type="button"
            mat-stroked-button
            (click)="cancelar()"
            class="!rounded-xl !border-slate-300 !text-slate-700 hover:!bg-slate-100 !px-5 !py-2.5 text-sm font-semibold transition-all">
            Volver a editar
        </button>

        <button 
            type="button"
            mat-flat-button
            (click)="confirmar()"
            [style.background-color]="data.color_primario || '#3b82f6'"
            class="!rounded-xl !text-white !px-6 !py-2.5 text-sm font-semibold shadow-md hover:brightness-105 active:scale-[0.99] transition-all flex items-center justify-center gap-2">
            <mat-icon [svgIcon]="'heroicons_outline:check'" class="!w-4 !h-4 !text-white"></mat-icon>
            <span>Confirmar y Enviar</span>
        </button>
    </div>

    <!-- Visor de imagen en pantalla completa (Overlay) -->
    <div *ngIf="imagenSeleccionada" 
         (click)="cerrarVisor()"
         class="absolute inset-0 z-50 bg-black/85 backdrop-blur-sm flex flex-col items-center justify-center p-4 animate-fade-in cursor-zoom-out">
        <div class="absolute top-4 right-4 flex items-center gap-2">
            <span class="text-xs text-white/80 bg-black/40 px-3 py-1 rounded-full font-medium">{{ imagenSeleccionada.nombre }}</span>
            <button 
                type="button" 
                (click)="cerrarVisor()" 
                class="p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors">
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="!w-6 !h-6 !text-white"></mat-icon>
            </button>
        </div>
        <img 
            [src]="'data:image/' + imagenSeleccionada.extension + ';base64,' + imagenSeleccionada.base64" 
            [alt]="imagenSeleccionada.nombre" 
            (click)="$event.stopPropagation()"
            class="max-w-full max-h-[80vh] rounded-lg shadow-2xl object-contain">
    </div>
</div>
